/**************************************************
 * Nombre:       Home_Galeria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Tab, Tabs, Typography} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import Tarjeta_Galeria from "../../Tarjetas/Tarjeta_Galeria";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";


const Home_Galeria = () => {
    const {sCell} = useResponsive()
    const [fotos, setFotos] = useState([]);
    const [eventos, setEventos] = useState([]);
    const [totalEventos, setTotalEventos] = useState([]);
    const [escogido, setEscogido] = useState('');


    const cambioEvento = (s) => {
        setEscogido(s)
        let arr = totalEventos.filter((e) => e.evento === s)
        console.log(arr)
        setFotos(arr)
    }

    useEffect(() => {

        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'galeriaFotos', wheres: w}).then((dox) => {
            let arr = dox.data
            setTotalEventos(arr)
            let arrEventos = arr.map((e) => e.evento)
            let setEvento = new Set(arrEventos)
            let eventos = new Array(...setEvento)
            setEventos(eventos)
            setEscogido(eventos[0])
            let arre = arr.filter((e) => e.evento === eventos[0])
            setFotos(arre)

        })

    }, [])


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, zIndex: 2}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{color: '#262626', fontSize: sCell ? 32 : 40, fontWeight: 700}}>
                                        Galería de Fotos
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 6}}
                                      sx={{justifyContent: 'flex-start', mt: 0}}>
                                    <Typography sx={{color: '#545454', fontSize: 16, fontWeight: 400, lineHeight: 1.2}}>
                                        Explora los momentos que marcan nuestra historia: eventos, capacitaciones,
                                        reconocimientos y encuentros.
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-end', mt: sCell ? 1 : 0}}>
                                    <Tabs value={escogido} onChange={(e, s) => cambioEvento(s)}>
                                        {eventos.map((e, i) => (
                                            <Tab label={e} value={e}/>
                                        ))}
                                    </Tabs>
                                </Grid>


                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Splide
                    aria-label="My Favorite Images" style={{width: '100%'}}
                    options={{
                        autoplay: true,
                        speed: 1500,
                        rewind: true,
                        perPage: sCell ? 1 : 3,
                        perMove: 1,
                        arrows: true,
                        pagination: false,
                        width: '100%',
                        drag: 'false',
                        interval: 5000,
                        noDrag: true,
                        gap: sCell ? 0 : 40,
                        focus: 'center',
                        padding: 20
                    }}
                >

                    {fotos.map((item, index) => {
                        return (
                            <SplideSlide key={`qe${index}`}>
                                <Tarjeta_Galeria item={item}/>
                            </SplideSlide>
                        )
                    })}
                </Splide>
            </Grid>

        </Grid>
    )

}
export default Home_Galeria

const items = [1, 2, 3, 4, 5, 6, 7, 8, 9]
